import { ERegionCode } from '../../interfaces';

export type TRegionCoverageMap = {
  region: string;
  [index: string]: string | null;
};

export type TAgeConfig = {
  region: ERegionCode;
  age: number;
};

/* VEHICLE FIELD SETTINGS */
export const ANNUAL_MILEAGE_STATES = ['CA'];
export const HAS_COMMERCIAL_VEHICLE_USE_OPTION = ['CA'];
export const ANTI_THEFT_DEVICE_STATES = ['CA', 'IL', 'PA'];
export const AUTOMATIC_EMERGENCY_BRAKING_STATES = ['SC'];
export const VEHICLE_STORAGE_STATES = ['CA'];
export const BUSINESS_USE_STATES = ['SC'];
export const EXCLUDE_PURCHASE_YEAR = ['CA'];
export const PASSIVE_RESTRAINT_STATES = ['PA'];
export const VEHICLE_USE_STATES = ['CA'];
export const VEHICLE_GARAGE_ADDRESS_EDIT_CRM_STATES = ['CA'];

/* DRIVER FIELD SETTINGS */
export const DEFENSIVE_DRIVER_STATES = ['SC', 'GA'];
export const HAS_DEGREE_OR_LICENSE_STATES = ['CA'];
export const HAS_EXCLUDE_DRIVER_NONDRIVER_REASON = ['CO'];
export const OCCUPATION_STATES = ['CA'];
export const SELECT_PRIMARY_DRIVER_STATES = ['CA'];
export const MATURE_DRIVER_ORG_AND_COURSE_STATES = ['VA'];
export const ASSIGN_VEHICLE_TO_DRIVER_STATES = ['VA'];

/* HEALTH CHECK FUNCTIONALITY SETTING */
export const SKIP_EXCLUDE_DRIVER_FOR_SPOUSE = ['OR'];

/* PLATFORM ONLY SETTINGS */
export const RIDESHARE_USE_STATES = ['AZ', 'IL', 'MO', 'OH', 'SC', 'TN', 'TX'];

/* DRIVER CONFIGS */
export const VEHICLE_CATEGORY_STATES = ['CA'];
export const MATURE_DRIVER_STATES_CONFIG: TAgeConfig[] = [
  {
    region: 'CA',
    age: 50,
  },
  {
    region: 'CO',
    age: 55,
  },
  {
    region: 'IL',
    age: 55,
  },
  {
    region: 'OH',
    age: 60,
  },
  {
    region: 'OR',
    age: 55,
  },
  {
    region: 'PA',
    age: 55,
  },
  {
    region: 'TN',
    age: 55,
  },
  {
    region: 'VA',
    age: 55,
  },
];

export const STUDENT_DRIVER_STATES_CONFIG: TAgeConfig[] = [
  {
    region: 'CA',
    age: 25,
  },
  {
    region: 'GA',
    age: 25,
  },
];

/* COVERAGE MAPS */
const IN_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'IN',
  '25000/50000': '50000/50000',
  '50000/50000': '25000/50000',
};

const PA_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'PA',
  '25000/50000': '50000/50000',
  '50000/50000': '25000/50000',
};

const WI_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'WI',
  '25000/50000': '50000/100000',
};

const VA_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'VA',
  '25000/50000': '50000/50000',
  '50000/50000': '25000/50000',
};

const CO_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'CO',
  '25000/50000': '50000/50000',
  '50000/50000': '25000/50000',
};

const GA_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'GA',
  '25000/50000': '50000/50000',
  '50000/50000': '25000/50000',
};

const OR_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'GA',
  '25000/50000': '50000/50000',
  '50000/50000': '25000/50000',
};

const MO_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'MO',
  '25000/50000': 'null',
  null: '25000/50000',
};

/* COVERAGE EXCEPTION MAPPINGS */
const WI_UMBI_UIMBI_COVERAGE_EXCEPTION = {
  region: 'WI',
  exceptions: [{ umbi: '25000/50000', uimbi: '50000/100000' }],
};

/* COVERAGE RULES */
export const REGION_COVERAGE_RULES = {
  CDW_REQUIRES_UMBI_AND_COLL: ['CA'],
  PD_CANNOT_EXCEED_BI: ['CA'],
  UIMBI_CANNOT_EXCEED_UMBI: ['PA', 'WI'],
  UMBI_MATCHES_UIMBI: ['IL', 'MO'],
  UMBI_UIMBI_COVERAGE_MAP: [
    IN_UMBI_UIMBI_COVERAGE_MAP,
    MO_UMBI_UIMBI_COVERAGE_MAP,
    CO_UMBI_UIMBI_COVERAGE_MAP,
    GA_UMBI_UIMBI_COVERAGE_MAP,
    OR_UMBI_UIMBI_COVERAGE_MAP,
    PA_UMBI_UIMBI_COVERAGE_MAP,
    VA_UMBI_UIMBI_COVERAGE_MAP,
    WI_UMBI_UIMBI_COVERAGE_MAP,
  ],
  UMBI_UIMBI_EXCEPTIONS: [WI_UMBI_UIMBI_COVERAGE_EXCEPTION],
  UMPD_REQUIRES_UMBI: ['IN', 'OH', 'TN', 'TX'],
  HIDE_UMBI_IF_UMPD_OFF: ['GA'],
  SKIP_UMPD_SIDE_EFFECT: ['CA'],
  SKIP_UIMBI_SIDE_EFFECT: ['OH', 'CA', 'PA'],
  VUMPD_REQUIRES_NO_COMP_COLL: ['OH'],
  UMPD_DEDUCTIBLE_REQUIRES_NO_COMP_COLL: ['CO'],
  COMP_COLL_REQUIRED_SEPARATELY: ['CA'],
  COLL_VUMPD_REQUIRE_MUTUAL_EXCLUSION: ['CA'],
};

export default {
  ANTI_THEFT_DEVICE_STATES,
  PASSIVE_RESTRAINT_STATES,
  AUTOMATIC_EMERGENCY_BRAKING_STATES,
  VEHICLE_CATEGORY_STATES,
  BUSINESS_USE_STATES,
  DEFENSIVE_DRIVER_STATES,
  MATURE_DRIVER_STATES_CONFIG,
  REGION_COVERAGE_RULES,
} as const;
